import { memo, useCallback, useRef, useState } from 'react';
import PlayerTimelineButton from '../TimelinePlayerActionBar/PlayerTimelineButton';
import ChaptersMenuPopover from './ChaptersMenuPopover';
import { useChapterParagraphs } from '@/components/molecules/Transcript/useChapterParagraphs';

const ChaptersMenuButton = () => {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);
  const chapters = useChapterParagraphs();

  const handleOpen = useCallback(() => {
    setIsOpen(true);
  }, []);

  const handleClose = useCallback(() => {
    setIsOpen(false);
  }, []);

  if (chapters.length === 0) {
    return null;
  }

  return (
    <div ref={containerRef} className="relative">
      <PlayerTimelineButton
        tooltipTitle="Chapters"
        buttonId="chapters-menu-button"
        onClick={handleOpen}
        iconName="IconList"
        isDisabled={false}
      />
      {isOpen && <ChaptersMenuPopover onClose={handleClose} buttonRef={containerRef} />}
    </div>
  );
};

export default memo(ChaptersMenuButton);
